import { IconCurrency } from "@repo/assets/images";
import cx from "classnames";
const CurrencySymbol = ({
  color,
  variant = "smallRegular",
  value
}) => <span className="flex items-center" data-sentry-component="CurrencySymbol" data-sentry-source-file="CurrencySymbol.jsx">
    <IconCurrency className={cx("me-1 fill-current rtl:order-2 rtl:ms-1", {
    color: color,
    "w-[24px] md:w-[28px]": variant === "mediumRegular",
    "w-[14px] md:w-[18px]": variant === "smallRegular",
    "w-[12px] md:w-[14px]": variant === "smallSpecial",
    "w-[18px] md:w-[20px]": variant === "mediumSpecial"
  })} data-sentry-element="IconCurrency" data-sentry-source-file="CurrencySymbol.jsx" />
    {value}
  </span>;
export default CurrencySymbol;